import Component from "./SearchCustomer";

export default Component;
